import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7.77 8.032C6.429 9.042 5.25 10.43 4.42 11.92l-.611-.34.612.34a.165.165 0 0 0 0 .16c.828 1.49 2.007 2.879 3.35 3.888 1.346 1.013 2.813 1.613 4.229 1.613s2.883-.6 4.23-1.613c1.342-1.01 2.521-2.398 3.35-3.888l.611.34-.612-.34a.165.165 0 0 0 0-.16c-.828-1.49-2.007-2.879-3.35-3.888C14.883 7.019 13.416 6.419 12 6.419s-2.883.6-4.23 1.613Zm-.84-1.12C8.436 5.78 10.192 5.02 12 5.02c1.807 0 3.563.76 5.07 1.894 1.512 1.136 2.817 2.678 3.733 4.328a1.564 1.564 0 0 1 0 1.518v.001c-.916 1.65-2.222 3.191-3.732 4.327-1.508 1.134-3.264 1.894-5.071 1.894s-3.563-.76-5.07-1.894c-1.512-1.136-2.817-2.678-3.733-4.328a1.564 1.564 0 0 1 0-1.518v-.001c.916-1.65 2.221-3.191 3.732-4.327Zm6.538 3.686a2.121 2.121 0 0 0-2.936 0 1.94 1.94 0 0 0 0 2.804 2.121 2.121 0 0 0 2.936 0 1.94 1.94 0 0 0 0-2.804ZM9.555 9.595a3.521 3.521 0 0 1 4.89 0 3.34 3.34 0 0 1 0 4.81 3.521 3.521 0 0 1-4.89 0 3.34 3.34 0 0 1 0-4.81Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
